import {
  LOAD_MANAGER_EMAIL_BY_ID,
  SET_MANAGER_EMAIL_BY_ID,
} from '../actions/emails';

const initialState = {
  activeEmail: null,
  activeEmailId: null,
  isLoading: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case LOAD_MANAGER_EMAIL_BY_ID: {
      return {
        ...state,
        activeEmail: null,
        activeEmailId: null,
        isLoading: true,
      };
    }

    case SET_MANAGER_EMAIL_BY_ID: {
      const { email: activeEmail } = action.payload;
      return {
        ...state,
        activeEmail,
        activeEmailId: activeEmail.id,
        isLoading: false,
      };
    }

    default:
      return state;
  }
};
